<template>
<q-page class="signup" :class="{'bg-white': !$isDesktop}">
  <div class="row justify-center items-center" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-md'">
    <q-card v-if="$isDesktop" class="col-6">
      <common-form action="/two-factor-challenge">
        <q-card-section class="q-pa-lg q-gutter-lg">
          <template v-if="!recovery">
            <p>Voer uw multifactor code in</p>
            <common-input name="code" v-model="form.code" label="Code"
                          :error-message="$hasError('code') ? 'Ongeldige code': ''"
                          :error="$hasError('code')"
            />
          </template>
          <template v-else>
            <p>Voer een van de herstel codes in</p>
            <common-input name="recovery_code" v-model="form.recovery_code" label="Herstel code"
                          :error-message="$hasError('recovery_code') ? 'Ongeldige herstel code': ''"
                          :error="$hasError('recovery_code')"
            />
          </template>
        </q-card-section>
        <q-separator />
        <q-card-actions align="between" class="q-py-md q-px-lg">
          <flat-button type="button" :label="recovery? 'Annuleren' : 'Code vergeten'"
                       @click="recovery=!recovery" />
          <accent-button type="submit" label="Volgende" />
        </q-card-actions>
      </common-form>
    </q-card>
    <div v-else class="col-xs-12 col-sm-10 q-mt-lg">
      <common-form action="/two-factor-challenge">
        <div class="row q-col-gutter-lg">
          <template v-if="!recovery">
            <p>Voer uw multifactor code in</p>
            <common-input name="code" v-model="form.code" label="Code"
                          class="col-12"
                          :error-message="$hasError('code') ? 'Ongeldige code': ''"
                          :error="$hasError('code')"
            />
          </template>
          <template v-else>
            <p>Voer een van de herstel codes in</p>
            <common-input name="recovery_code" v-model="form.recovery_code" label="Herstel code"
                          :error-message="$hasError('recovery_code') ? 'Ongeldige herstel code': ''"
                          :error="$hasError('recovery_code')"
            />
          </template>
        </div>
        <q-separator />
        <div class="row justify-between q-mt-md">
          <accent-button type="submit" label="Volgende" />
        </div>
      </common-form>
    </div>
  </div>
</q-page>
</template>

<script>
import FlatButton from '../../components/button/FlatButton.vue'

export default {
  components: { FlatButton },
  data() {
    return {
      recovery: this.$hasError('recovery_code'),
      form: {
        code: '',
        recovery_code: '',
      },
    }
  },
}
</script>
